import React from "react";
import { Form } from "@redriver/cinnamon";
import { getVatRates } from "./actions";

export const VATDropdown = (props) => (
  <Form.Dropdown {...props} lookupAction={getVatRates} />
);

export default VATDropdown;
